export enum EventStatus {
  Empty = '',
  Running = 'running',
  Finished = 'finished',
  Enabled = 'enabled',
  NotEnabled = 'not_enabled',
  StartingSoon = 'starting_soon',
  StartingVerySoon = 'starting_very_soon',

}
